export function departmentException (roles, login = false) {
  const departmentSlugs = [...new Set(roles.map(item => item.team.teamable.slug))];

  if (login) return departmentSlugs.includes('gesso-colatura') || departmentSlugs.includes('gesso-finitura') || departmentSlugs.includes('cam');

  return (departmentSlugs.includes('gesso-colatura') || departmentSlugs.includes('gesso-finitura'));
};
